import React, { useState, useRef, useEffect } from 'react'
import DOMPurify from 'dompurify'
import { Link, makeStyles } from '@material-ui/core'

const RichTextRenderer = ({ htmlContent, expanded }) => {
  const classes = useStyles()
  const [isClamped, setIsClamped] = useState(true)
  const sanitizedHtml = DOMPurify.sanitize(htmlContent)

  const [showLink, setShowLink] = useState(false)
  const contentRef = useRef(null)

  useEffect(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight
      setShowLink(height > 100)
    }
  }, [sanitizedHtml])

  const isControlledExpanded = expanded !== undefined
  const shouldClamp = isControlledExpanded ? !expanded : isClamped

  return (
    <div>
      <div
        ref={contentRef}
        className={`${classes.contentStyling} ${shouldClamp ? classes.clampedContent : ''}`}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
      {!isControlledExpanded && showLink && (
        <Link className={classes.button} onClick={() => setIsClamped(!isClamped)}>
          {!isClamped ? 'View less...' : 'View more...'}
        </Link>
      )}
    </div>
  )
}

export default RichTextRenderer

const useStyles = makeStyles((theme) => ({
  contentStyling: {
    // Rich text content styling
    '& p': {
      margin: '0px 0px 8px 0px',
      padding: '0px'
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      fontWeight: 'bold',
      margin: '4px 0'
    },
    '& ul': {
      'padding-inline-start': '40px'
    },
    // Block quote styling
    '& blockquote': {
      color: '#656d76',
      margin: '16px 0',
      fontStyle: 'italic',
      borderLeft: '4px solid #d8dee4',
      padding: '8px 0px 4px 16px',
      backgroundColor: '#f8f9fa'
    },
    // Inline code styling
    '& code': {
      border: '1px solid #d8dee4',
      padding: '2px 4px',
      fontSize: '85%',
      fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
      borderRadius: '4px',
      backgroundColor: '#f6f8fa',
      color: '#24292e'
    },
    // Code block styling
    '& pre': {
      backgroundColor: '#f6f8fa',
      border: '1px solid #e1e4e8',
      borderRadius: '6px',
      padding: '16px',
      overflow: 'auto',
      margin: '16px 0',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    },
    '& pre code': {
      backgroundColor: 'transparent',
      border: 'none',
      padding: '0',
      color: '#24292e',
      fontSize: '14px'
    }
  },
  clampedContent: {
    display: '-webkit-box',
    '-webkit-line-clamp': 6,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  },
  button: {
    marginLeft: '10px',
    color: theme.palette.primary.main,
    letterSpacing: '0.65px',
    textTransform: 'none !important',
    marginTop: '8px',
    cursor: 'pointer'
  }
}))
